// extracted by mini-css-extract-plugin
export default {"container":"PageNotFound_container__Q4k9y","inner":"PageNotFound_inner__7gqaE","goBack":"PageNotFound_goBack__GX+Aw"};